import { useDeleteOneWorker } from "#src/components/hooks/adapters/useWorkers";
import { Button, Dialog } from "@validereinc/common-components";
import type { WorkerType } from "@validereinc/domain";
import React from "react";

export type DeleteWorkerDialogProps = {
  worker?: WorkerType;
  onClose: () => void;
  onDeleted?: () => void;
};

/**
 * Confirms permanent deletion of a worker. Used from the workers list and worker detail.
 */
export const DeleteWorkerDialog = ({
  worker,
  onClose,
  onDeleted,
}: DeleteWorkerDialogProps) => {
  const deleteMutation = useDeleteOneWorker({
    onSuccess: () => {
      onDeleted?.();
      onClose();
    },
  });

  const isOpen = worker != null;

  return (
    <Dialog
      title="Delete worker"
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          key="delete"
          variant="error"
          isLoading={deleteMutation.isLoading}
          onClick={() => {
            if (worker == null) return;
            deleteMutation.mutate({ id: worker.id });
          }}
        >
          Delete worker
        </Button>,
      ]}
    >
      Are you sure you want to delete <strong>{worker?.name ?? ""}</strong>?
      This cannot be undone.
    </Dialog>
  );
};
